import React, { useMemo } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography
} from "@material-ui/core";
import { AsyncDropdown } from "src/apps/commons/dropdowns";
import { IRemyndWarrantyProductMapSaveReqTemp } from "../types";
import { listAllRemyndProducts } from "src/apps/commons/dropdowns/api";

const useStyles = makeStyles(_ => ({
  container: {
    "& > *": {
      padding: "12px 6px"
    }
  }
}));

interface Props {
  label: string;
  open: boolean;
  defaultValue?: IRemyndWarrantyProductMapSaveReqTemp;
  existingValues?: IRemyndWarrantyProductMapSaveReqTemp[];
  handleCloseModal: () => void;
  handleSubmitModal: (value: IRemyndWarrantyProductMapSaveReqTemp) => void;
}

const schema = yup.object().shape({
  product: yup.object().typeError("กรุณาเลือกสินค้า")
});

const WarrantyProductModal: React.FC<Props> = props => {
  const classes = useStyles();
  const {
    open,
    label,
    defaultValue,
    handleCloseModal,
    handleSubmitModal,
    existingValues
  } = props;

  const excludedFromDropdown = useMemo(
    () =>
      existingValues
        ?.map(v => v.product.value)
        ?.filter(value => value !== defaultValue?.product?.value),
    [existingValues, defaultValue]
  );

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm<PartialNull<IRemyndWarrantyProductMapSaveReqTemp>>({
    defaultValues: { ...defaultValue },
    resolver: yupResolver(schema)
  });

  return (
    <Dialog
      open={open}
      onClose={handleCloseModal}
      maxWidth="md"
      fullWidth
      aria-labelledby="form-dialog-title"
    >
      <form onSubmit={handleSubmit(handleSubmitModal)}>
        <DialogTitle id="form-dialog-title" disableTypography>
          <Typography variant="h3">
            {!defaultValue ? "เพิ่ม " : "แก้ไข "}
            {label}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container className={classes.container}>
            <Grid item xs={12}>
              <Controller
                name="product"
                control={control}
                defaultValue={defaultValue?.product ?? null}
                render={({ field: { onChange, value } }) => (
                  <AsyncDropdown
                    label="สินค้า"
                    fetchDropdown={listAllRemyndProducts}
                    paginate={{
                      page: 1,
                      pageSize: 2000,
                      order: {
                        optionKey: "NAME_TH",
                        desc: false
                      }
                    }}
                    excludedDropdownValues={excludedFromDropdown}
                    onChange={onChange}
                    value={value}
                    error={Boolean(errors.product)}
                    helperText={errors.product?.message}
                  />
                )}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          {!defaultValue ? (
            <Button
              key="addBtn"
              variant="contained"
              color="primary"
              type="submit"
            >
              Add
            </Button>
          ) : (
            <Button
              key="updateBtn"
              variant="contained"
              color="primary"
              type="submit"
            >
              Update
            </Button>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default WarrantyProductModal;
